import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { GridFindContext } from "abreact/grid/generic/GridFindContext";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { abMarkdownColorPlugin } from "abreact/input/markdown/AbMarkdownColorPlugin";
import { abMarkdownEzGraphPlugin } from "abreact/input/markdown/AbMarkdownEzGraphPlugin";
import { abMarkdownPersonPlugin } from "abreact/input/markdown/AbMarkdownPersonPlugin";
import { AbShowMoreTextContainer } from "abreact/layout/AbShowMoreTextContainer";
import { AbMarkdownReactRenderer } from "abreact/misc/AbMarkdownReactRenderer";
import { AbWithTooltip } from "abreact/popup/AbWithTooltip";
import * as React from "react";
import { Remarkable } from "remarkable";
export class AbMarkdownContent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "remarkable", void 0);
    _defineProperty(this, "gridFindRegExp", null);
    this.remarkable = new Remarkable({
      breaks: false,
      // DO NOT make newlines render as <br>; leave them as \n.
      linkTarget: "_blank" // links render so they appear in a new tab
    });
    this.remarkable.use(abMarkdownColorPlugin); // tell remarkable how to parse colors
    this.remarkable.use(abMarkdownPersonPlugin);
    this.remarkable.use(abMarkdownEzGraphPlugin);
    this.remarkable.inline.ruler.enable(["ins"]); // underline foo in '++foo++'

    // Replace the Remarkable standard renderer with a React renderer.  'as any' because they want a string, and we want a ReactNode.
    // We can't pass this.gridFindRegExp here, because its value is set in the render().  So we pass the container object instead.
    // We COULD pass this.props.isHighlighted, but we're already passing the container, so why bother.
    this.remarkable.renderer = new AbMarkdownReactRenderer(this, props.customCodeToolbarFixedGroup, props.codeBlocksUsePre);

    // To allow "data:" as a valid URL in an image link, monkey-patch the inline validator.
    // See https://github.com/jonschlinkert/remarkable/issues/329
    const originalLinkValidator = this.remarkable.inline.validateLink;
    if (originalLinkValidator) {
      const dataLinkRegex = /^data:([-\w]+\/[-+\w.]+)?(;?\w+=[-\w]+)*(;base64)?,.*$/i;
      this.remarkable.inline.validateLink = url => originalLinkValidator(url) || url.match(dataLinkRegex);
    }
  }
  render() {
    return /*#__PURE__*/React.createElement(GridFindContext.Consumer, null, context => {
      this.gridFindRegExp = context?.gridFindRegExp ?? null;
      const markdown = this.props.markdown ?? this.props.value;
      const renderedMarkdown = markdown ? this.remarkable.render(markdown) : undefined;
      const content = /*#__PURE__*/React.createElement(AbWithTooltip, {
        tooltip: this.props.tooltip
      }, /*#__PURE__*/React.createElement("div", ReactUtils.componentProps("ab-markdown-content", this.props), renderedMarkdown, this.props.children));
      return this.props.truncateLongContent ? /*#__PURE__*/React.createElement(AbShowMoreTextContainer, null, content) : content;
    });
  }
}
//# sourceMappingURL=AbMarkdownContent.js.map
